import styled from "styled-components";
import { colors } from "../../../../../../theme/theme";

export const ModalContent = styled.div`
   color: ${colors.greyscale.black};
`

export const DropdownFilter = styled.div`
    .p-dropdown{
        width: 100%;
        max-height: 45px;
        font-size: 14px;
    }

    .p-dropdown-panel{
         max-width: 100%;
    }

    .p-dropdown .p-dropdown-label{
        padding: 10px;
    }
`

export const MultiSelectFilter = styled.div`
    .multiselect-dropdown{
        width: 100%;
        max-height: 40px;
        font-size: 14px;
    }

    .p-multiselect .p-multiselect-panel{
        max-width: 100%;
    }

    .p-multiselect .p-multiselect-label.p-placeholder{
        color: ${colors.greyscale.grey2};
    }

    .p-disabled{
       background-color: ${colors.greyscale.grey2};
       border-color: ${colors.greyscale.grey};
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item-group{
        background-color: ${colors.greyscale.light_grey};
    }
`;
export const CustomTable = styled.div`
    margin-top: 5px;
    height: 70%;
    overflow-y: scroll;
    width: 100%;
    padding: 0px 20px 0px 15px;
    
    .tableHeader {
        color: ${colors.greyscale.darker_grey};
        font-weight: bold;
    }

    .tableCard {
        border: 1px solid ${colors.greyscale.light_grey};
        border-radius: 4px;
        padding: 5px;
        display: flex;
        align-items: center;

        .secondaryTitle{
            color: ${colors.greyscale.dark_grey};
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
`

export const CustomVerification = styled.div`
    overflow-y: scroll;
    height: 85%;
    width: 100%;
    padding: 0px 20px 0px 15px;

    .tableCard{
        padding: 10px 0px;
        background-color: ${colors.mainColors.white_lilac};    
        border-left: 4px solid ${colors.mainColors.blueberry};
        word-break: break-all;

        &.card-item{
            border-left: 4px solid ${colors.mainColors.verde_dstore};
            padding-left: 15px;
        }

        &.card-theme{
            border-left: 4px solid ${colors.mainColors.roxo_delinea};
            padding-left: 15px;
        }

        &.card-media{
            border-left: 4px solid ${colors.mainColors.capri};
            padding-left: 25px;
        }
    }
`
